import type { BaseAPIResponse } from '~/types/api';
import type { AssignLicensePayload, PurchaseLicenseFor, RefundLicenseResponse } from '~/types/licenses/licenses';
import { pbRequestRaw, pbRequestVoid } from '~/services/request';

export const licenseService = {
    async assignLicense(personId: number, licenseId: number, contact: PurchaseLicenseFor): Promise<void> {
        const nuxtApp = useNuxtApp();

        const payload: AssignLicensePayload = {
            assigned_to_id: contact.id,
            type: contact.type
        };

        await pbRequestVoid(nuxtApp.$api.routes.people.licenses.update_license(personId, licenseId), {
            method: 'PATCH',
            body: JSON.stringify(payload),
            failure: 'Failed to assign license',
        });
    },

    async refundLicense(personId: number, licenseId: number, payload: { reason: string }): Promise<BaseAPIResponse<RefundLicenseResponse>> {
        const nuxtApp = useNuxtApp();

        // The envelope is read whole: the caller threads the refund's own post-state forward.
        return await pbRequestRaw<BaseAPIResponse<RefundLicenseResponse>>(
            nuxtApp.$api.routes.people.licenses.refund(personId, licenseId),
            {
                method: 'DELETE',
                body: JSON.stringify(payload),
                failure: 'Failed to refund license',
            }
        );
    },

    async updateLicense(personId: number, licenseId: number, payload: { renew: boolean }): Promise<void> {
        const nuxtApp = useNuxtApp();

        await pbRequestVoid(nuxtApp.$api.routes.people.licenses.update_license(personId, licenseId), {
            method: 'PATCH',
            body: JSON.stringify(payload),
            failure: 'Failed to update license',
        });
    },

    async unassignLicense(personId: number, licenseId: number): Promise<void> {
        const nuxtApp = useNuxtApp();

        await pbRequestVoid(nuxtApp.$api.routes.people.licenses.update_license(personId, licenseId), {
            method: 'PATCH',
            body: JSON.stringify({ assigned_to_id: null }),
            failure: 'Failed to unassign license',
        });
    },

    // License Downgrade at Renewal: cancel a pending scheduled change (DELETE on the same
    // change route). The license keeps renewing as its current plan.
    async cancelScheduledChange(personId: number, licenseId: number): Promise<void> {
        const nuxtApp = useNuxtApp();

        await pbRequestVoid(nuxtApp.$api.routes.people.licenses.change_license(personId, licenseId), {
            method: 'DELETE',
            failure: 'Failed to cancel scheduled change',
        });
    },

};
